import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrentUserModule } from '®shared/current-user';

import { SectionResolverStoreModule } from '../resolver-store';

import { CanActivateDraftSectionView } from './can-activate-draft-section-view.service';
import { CanActivateSectionView } from './can-activate-section-view.service';
import { SectionResolver } from './section-resolver.service';

@NgModule({
  imports: [CommonModule, CurrentUserModule, SectionResolverStoreModule],
  providers: [
    CanActivateDraftSectionView,
    CanActivateSectionView,
    SectionResolver,
  ],
})
export class SectionResolverModule {}
